<div class="p-grid p-dir-col">
  <div class="p-col center-content">
    <p-progressSpinner></p-progressSpinner>
  </div>
  <div class="p-col center-content">
    {{ message }}
  </div>
</div>